goog.provide("shadow.js.shim.module$src$svg$objects$rectangle_split_top_and_left_svg$default");
shadow.js.shim.module$src$svg$objects$rectangle_split_top_and_left_svg$default = shadow.js.shim.module$src$svg$objects$rectangle_split_top_and_left_svg.default;
